var e={fontElementMap:"bzEEy",orderedlist:"zOuvR",bulletedlist:"xErDo",listItem:"_04hd2"};export{e as T};
//# sourceMappingURL=lists-60ec0614.js.map
